// GET DATA UPCOMING EVENT
export const GET_MS_PAYMENT_REQUEST = 'GET_MS_PAYMENT_REQUEST'
export const GET_MS_PAYMENT_FAILED = 'GET_MS_PAYMENT_FAILED'
export const GET_MS_PAYMENT_SUCCESS = 'GET_MS_PAYMENT_SUCCESS'

    